export enum BusinessType {
  B2B = 'B2B',
  B2C = 'B2C',
  BOTH = 'BOTH'
}
